export interface PromotionModel {
  conditions: PromotionConditionModel[];
  values: PromotionValueModel[];
}
export interface PromotionValueModel {
  logicType: LogicalTermEnum;
  type: string;
  discountValue: number;
  discountType: string;
  maximumAmountValue: number;
  productIds: number[];
  numberOfGifts: number;
}

export interface PromotionConditionModel {
  type: string;
  logicType: LogicalTermEnum;
  subtotalValue?: number;
  numberOfProduct?: number;
  productIds?: number[];
  dateAndTime?: Date;
}

export enum LogicalTermEnum {
  Or,
  And,
}

export abstract class PromotionConst {
  public static promotionConditionType = {
    startDate: "StartDate",
    endDate: "EndDate",
    numberOfUses: "NumberOfUses",
    forNewCustomer: "ForNewCustomer",
    buyAtLeastXProductInListProduct: "BuyAtLeastXProductInListProduct",
    subtotalAtLeastX: "SubtotalAtLeastX",
  };
  public static promotionValueType = {
    discount: "Discount",
    gift: "Gift",
  };
  public static discountType = {
    percent: "Percent",
    amount: "Amount",
  };
}
